import { render, staticRenderFns } from "./QywxTrialDetail.vue?vue&type=template&id=7589d6c8&"
import script from "./QywxTrialDetail.vue?vue&type=script&lang=js&"
export * from "./QywxTrialDetail.vue?vue&type=script&lang=js&"
import style0 from "./QywxTrialDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports